import styled from 'styled-components';

interface ISection {
    bgColor?: string;
    bgImage?: string;
}

const Section = styled.section`
    min-height: 100vh;
    width: 100%;
    padding: 40px 0px;
    background-color: ${ ({ bgColor }: ISection) => (bgColor) ? bgColor : "none" };
    background-image: ${ ({ bgImage }: ISection) => (bgImage) ? bgImage : "none" };
`;

export default Section;